import { useCallback, useEffect, useRef, useState } from 'react';
import { copyTextToClipboard } from '../utils/clipboard';

const COPIED_FEEDBACK_MS = 1500;

interface CopyToClipboard {
    copied: boolean;
    copy: (text: string) => Promise<boolean>;
}

export function useCopyToClipboard(feedbackMs: number = COPIED_FEEDBACK_MS): CopyToClipboard {
    const [copied, setCopied] = useState(false);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(
        () => () => {
            if (timerRef.current !== null) clearTimeout(timerRef.current);
        },
        []
    );

    const copy = useCallback(
        async (text: string): Promise<boolean> => {
            const ok = await copyTextToClipboard(text);
            if (!ok) return false;
            if (timerRef.current !== null) clearTimeout(timerRef.current);
            setCopied(true);
            timerRef.current = setTimeout(() => setCopied(false), feedbackMs);
            return true;
        },
        [feedbackMs]
    );

    return { copied, copy };
}
